import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  openSearchInput,
  closeSearchInput
} from 'bento-ordering/base/actions/searchInput';
import { useMenu } from 'bento-ordering/context/MenuContext';
import MenuSectionsBarItems from 'components/Menu/MenuSectionsBarItems';

export const MARGIN_OFFSET = 141;

const MenuSectionsBar = () => {
  const menu = useSelector(state => state.menu);
  const menuItemsDetail = useSelector(state => state.menuItemsDetail);
  const numberOfMenuItems = menuItemsDetail?.allIds?.length ?? 0;
  const isSearchInputOpen = useSelector(state => state.searchInput.isOpen);
  const dispatch = useDispatch();
  const { searchTerm, setSearchTerm } = useMenu();

  const handleOpenSearchInput = () => {
    dispatch(openSearchInput());
  };

  const handleCloseSearchInput = () => {
    dispatch(closeSearchInput());
  };

  if (menu.isFetching) {
    return null;
  }

  return (
    <MenuSectionsBarItems
      marginOffset={MARGIN_OFFSET}
      menu={menu}
      numberOfMenuItems={numberOfMenuItems}
      isSearchInputOpen={isSearchInputOpen}
      handleOpenSearchInput={handleOpenSearchInput}
      handleCloseSearchInput={handleCloseSearchInput}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default MenuSectionsBar;
